import React from 'react';

const SepaV = () => {
    return (
        <div className="sepa-v"></div>
    );
};

export default SepaV;